import { AppConfig } from '../../../shared/config/app-config';
import { FVSDataService } from './fvs-data.service';
import { FVSFeatureFlagService } from './fvs-feature-flags.service';
import { Injectable } from '@angular/core';
import FVSConstants from '../../../shared/models/nav-item-v2.constants';

@Injectable({
    providedIn: 'root',
})
export class FVSBRMLGAUpdateHelperService extends FVSFeatureFlagService {
    constructor(private fvsDataService: FVSDataService, public config: AppConfig) {
        super(config);
    }

    async getBRMOnboardingStatusOnFVS(isFlagEnabled: boolean) {
        if (!isFlagEnabled) {
            return FVSConstants.fvsOnboardingStatus.notOnboarded;
        }

        try {
            const response = await this.fvsDataService.getBRMStatusOnFVS();

            if (!response?.requestSuccessful) {
                throw response;
            }

            const onboardedOnFvs = Boolean(response?.responseBody?.onboardedOnFvs);
            const registeredRequiredLgas = Boolean(response?.responseBody?.registeredRequiredLgas);

            if (!onboardedOnFvs) {
                return FVSConstants.fvsOnboardingStatus.notOnboarded;
            }

            if (onboardedOnFvs && registeredRequiredLgas) {
                return FVSConstants.fvsOnboardingStatus.onboardedWithRegisteredLGA;
            }

            return FVSConstants.fvsOnboardingStatus.onboardedWithoutRegisteredLGA;
        } catch (error) {
            return FVSConstants.fvsOnboardingStatus.notOnboarded;
        }
    }

    canContinueOtherLoginChecks(onboardedStatus = '') {
        const { notOnboarded, onboardedWithRegisteredLGA } = FVSConstants.fvsOnboardingStatus;

        return onboardedStatus === notOnboarded || onboardedStatus === onboardedWithRegisteredLGA;
    }

    checkHasLGAOnFVS(onboardedStatus = '') {
        return onboardedStatus === FVSConstants.fvsOnboardingStatus.onboardedWithRegisteredLGA;
    }

    checkNotOnboarded(onboardedStatus = '') {
        return onboardedStatus === FVSConstants.fvsOnboardingStatus.notOnboarded;
    }
}
